import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../../Components/internal-pages/Leftimg_rightContent";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import Pageheader from "../../Components/internal-pages/Page_header";

const Responsibility =()=>{
    const CTAContent = [
        {
          pageHeaderName: "Sustainability",
          pageParagraphitalic: "Building a Greener Tomorrow",
          pageParagraphText:
            "At eYantra, sustainability isn’t just a buzzword – it’s at the heart of everything we do. We are committed to making a meaningful difference by creating environmentally responsible solutions that benefit both businesses and the planet. From sourcing eco-friendly materials for our corporate gifting products to implementing energy-efficient practices in our operations, we make sure that every decision we make reflects our dedication to a sustainable future.",
          ContactFormName: "responsibility",
        },
      ];
    
      const [viewMore, setViewMore] = useState(false)
      const handleViewMore =  ()=>{
        setViewMore(Prev=> !Prev)

      }
      const ContentImg = [
        {
          index: 0,
          leftImg: "../assests/images/who-we-are/Safety and Compliance.jpg",
          leftHeading: "Safety & Compliance",
          leftSmallpara: "Protecting People and Brands",
          leftParagraph:<>
              <p>
                  The safety of our people and the protection of the brands we serve are our top priorities. We adhere to the most stringent safety practices throughout our operations, from the materials we select to the logistics systems that deliver our corporate gifts. This guarantees that every product we provide is not only innovative but also safe and secure. By placing safety first, we protect our employees, clients, and partners, guaranteeing that each interaction is positive and secure. 
              </p>
              {viewMore && 
                <p className="">
                Simultaneously, we uphold the highest standards of compliance in every aspect of our business. Whether it’s adhering to local regulations or guaranteeing our suppliers meet rigorous standards, we are committed to transparency, integrity, and responsibility. Compliance at eYantra goes beyond following the rules; it is about building trust in every product, every partnership, and every action we take. 
                </p> 
            }
              <p className="text-start fw-bold" onClick={handleViewMore} style={{cursor:'pointer'}}>
                {viewMore ? 'View Less' : 'View More'}
              </p>

            
              
            </>,
          leftRedirectUrl: "/contact-us",
        },

      ];

     
     
    return(
        <>
            <Helmet>
                <title>Responsibility</title>
            </Helmet>
            <div className="p-0 m-2">
        {/* <Ctapage data={CTAContent} /> */}
        <Pageheader data={CTAContent}/>
        
        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <div className="my-5">
          <ClinetsLogoSlider />
        </div>
        <Whychooseus />
      </div>
        </>
    )
}

export default Responsibility;